var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBuildManually(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6170_451993)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45 22.4987C45 23.3118 44.9566 24.1164 44.8719 24.907C44.7567 25.9915 44.5625 27.0512 44.3005 28.0844C42.1407 36.5422 35.1889 43.0825 26.509 44.6446C25.208 44.8792 23.867 45 22.4982 45C22.4163 45 22.3343 45 22.2524 44.9966C9.93902 44.8669 0 34.8442 0 22.4987C0 10.0738 10.0727 0 22.4982 0C34.9255 0 45 10.0738 45 22.4987Z",
    fill: "#FB5919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.2994 28.0861C42.1396 36.5439 35.1878 43.0842 26.5079 44.6462L16.3672 34.5047C16.5055 34.6032 16.6724 34.6716 16.8551 34.6854L32.8222 35.9839C33.3576 36.0273 33.8266 35.6278 33.8696 35.0946L35.1448 19.3934C35.1633 19.1607 35.1003 18.9448 34.9791 18.7656L44.2994 28.0861Z",
    fill: "#C14014"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.8612 18.6126L18.8802 28.8364C18.4727 29.1846 17.8597 29.1372 17.5114 28.7297L15.7115 26.6203L11.2663 21.4097L7.11043 16.5405C6.7637 16.1325 6.81143 15.5194 7.21994 15.1721L19.2009 4.94883C19.6083 4.59832 20.2228 4.64798 20.5696 5.055L29.7543 15.8181L30.9705 17.2423C30.9762 17.2508 30.9848 17.2588 30.9905 17.2666C31.3159 17.6765 31.2625 18.2691 30.8612 18.6126Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5205 19.9173L28.6957 28.6989L25.9345 33.7239C25.6753 34.1929 25.0855 34.3658 24.6161 34.1066L15.5088 29.104L11.2106 26.741L10.5746 26.3913C10.2724 26.2272 10.0955 25.9244 10.0723 25.6034C10.0723 25.6034 10.0723 25.6034 10.0723 25.6014C10.061 25.4244 10.0969 25.2415 10.1903 25.0725L14.9565 16.398L17.7753 11.2681C18.0345 10.7968 18.6258 10.6263 19.0949 10.8832L30.6603 17.2399L33.1351 18.6007C33.607 18.8576 33.7783 19.448 33.5205 19.9173Z",
    fill: "#255873"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1443 19.3905L33.8692 35.0921C33.8261 35.6252 33.3571 36.0246 32.8217 35.9814L16.8546 34.6829C16.672 34.6684 16.5051 34.6022 16.3667 34.5036C16.2778 34.4418 16.2041 34.3656 16.1425 34.2799C16.0129 34.0985 15.9453 33.8741 15.964 33.6353L17.2419 17.9355C17.2849 17.4001 17.7512 17.003 18.2864 17.0462L34.2564 18.3448C34.4304 18.3593 34.5918 18.4189 34.7254 18.5119C34.8263 18.5794 34.9096 18.6657 34.9786 18.7651C35.0998 18.9422 35.1628 19.1601 35.1443 19.3905Z",
    fill: "#FBBA19"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6170_451993"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 45,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuildManually);
export default __webpack_public_path__ + "static/media/build_manually.eb2eb6ee3fb9aea4dc59fcdc08356877.svg";
export { ForwardRef as ReactComponent };